export default __webpack_public_path__ + "static/media/ic_cancel_orange.da9b0c60.svg";